import React, { useEffect, useState } from "react";
import LoadingIndicator from "react-loading-indicator";
import Modal from "../../../../Components/Modal";
import * as sc from "./UpdateCampaignChannelsModal.styled";
import Actions from "../../../../Actions";
import { getPlatformUrl } from "../../../../utils/Helpers";
import { channelsFieldsByShortName } from "../../../../data/app__channelFields";
import { useTranslation } from "react-i18next";

const UpdateCampaignChannelsModal = ({
  showModal,
  setShowModal,
  campaignData,
  channels = [],
  isClientView = false
}) => {
  const { t } = useTranslation();
  const [channelResponses, updateChannelResponses] = useState([]);

  const getChannelCampaignId = (channel) => campaignData[channelsFieldsByShortName[channel]?.name];

  const getPlatformHref = (data) => {
    return getPlatformUrl({
      channel: data.channel,
      campaignId: getChannelCampaignId(data.channel),
      fbAccountId: campaignData.fbAccountId
    });
  };

  useEffect(() => {
    if (!channels.length) {
      return;
    }
    const channelResponses = channels.map((channel) => ({
      channel,
      loading: true,
      hasError: false,
      platformAdIds: [],
      platformAdGenerated: !!getChannelCampaignId(channel)
    }));

    updateChannelResponses(channelResponses);
  }, [channels]);

  useEffect(() => {
    if (isClientView) return;

    const ref = Actions.updateDestinationLink.completed.listen(({ payload }) => {
      const channelResponses = payload.map((response) => ({
        channel: response.channel,
        loading: false,
        hasError: response.status !== "SUCCESS",
        platformAdIds: response.platformAdIds,
        platformAdGenerated: !!getChannelCampaignId(response.channel)
      }));

      updateChannelResponses(channelResponses);
    });

    return () => {
      ref();
    };
  }, []);

  return (
    <Modal
      onClose={() => {
        setShowModal(false);
      }}
      headline={t("Change Link")}
      isOpen={showModal}
    >
      <sc.ModalContainer>
        {channelResponses.map((data) => {
          return (
            <sc.ChannelResponseContainer key={data.channel}>
              {data.platformAdGenerated ? (
                <>
                  <sc.ChannelResponseIcon>
                    {data.loading && <LoadingIndicator />}
                    {!data.loading && (data.hasError || !data.platformAdIds.length) && "⛔"}
                    {!data.loading && !data.hasError && !!data.platformAdIds.length && "✅"}
                  </sc.ChannelResponseIcon>
                  <sc.ChannelResponseContent>{data.channel}</sc.ChannelResponseContent>
                  {!data.loading && data.hasError && !isClientView && (
                    <span>
                      <span>{t("Update failed")} </span>
                      <span>
                        <sc.PlatformAdLink
                          href={getPlatformHref(data)}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <span>({t("Change manually here")})</span>
                        </sc.PlatformAdLink>
                      </span>
                    </span>
                  )}
                  {!data.loading && data.hasError && isClientView && (
                    <span>{t("A campaign manager will update manually")}</span>
                  )}
                  {!data.loading && !data.hasError && isClientView && <span>{t("Updated")}</span>}
                  {!data.loading && !data.hasError && !isClientView && (
                    <span>
                      {data.platformAdIds.length ? (
                        <sc.PlatformAdLink
                          href={getPlatformHref(data)}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <span>{t("Go to ad platform")}</span>
                        </sc.PlatformAdLink>
                      ) : (
                        <>{t("No platform ads to update")}</>
                      )}
                    </span>
                  )}
                </>
              ) : (
                <>
                  <sc.ChannelResponseIcon>✅</sc.ChannelResponseIcon>
                  <sc.ChannelResponseContent>{data.channel}</sc.ChannelResponseContent>
                  <span>{t("Updated")}</span>
                </>
              )}
            </sc.ChannelResponseContainer>
          );
        })}
      </sc.ModalContainer>
    </Modal>
  );
};

export default UpdateCampaignChannelsModal;
